import {getService} from "~/lib/services/services-manager";

export async function checkMaxUsersQuota(clientUUID: string) {
  const service = getService("server-app");
  const result = await service.get(`/quotas/client/${clientUUID}/max-users`);
  return result.data;
}